import { Input } from "@/components/ui/input";
import { CRYPTO_CURRENCY_OPTIONS, CURRENCY_OPTIONS } from "@/utils/constant";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  Briefcase,
  DollarSign,
  CreditCard,
  LinkIcon,
  Star,
} from "lucide-react";
import { useState } from "react";

interface ContactPerson {
  name: string;
  email: string;
  phone: string;
}

interface Location {
  address: string;
  city: string;
  country: string;
}

interface EnterpriseProfileInfoProps {
  isEditing: boolean;
  formData: {
    companyName: string;
    industryType: string;
    contactPerson: ContactPerson;
    location: Location;
    preferredCurrency: string;
    preferredPaymentMethod: string;
    vatOrGstId: string;
    socialMediaProfile: string;
    reviews: object;
  };
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => void;
}

export const EnterpriseProfileInfo = ({
  isEditing,
  formData,
  handleInputChange,
}: EnterpriseProfileInfoProps) => {
console.log(formData);

  const [errors, setErrors] = useState<{ socialMediaProfile?: { message: string } }>({});
  const handleInputChangeWithValidation = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Update form data first
    handleInputChange(e);

    // Social media validation
    if (name === "socialMediaProfile" && value) {
      const linkedinRegex = /^https:\/\/(www\.)?linkedin\.com/;
      if (!linkedinRegex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          socialMediaProfile: { message: "Link must start with https://www.linkedin.com or https://linkedin.com" },
        }));
      } else {
        // Clear error if valid
        setErrors((prev) => ({ ...prev, socialMediaProfile: undefined }));
      }
    }
  };

  return (
    <div className="text-center mb-6">
      {isEditing ? (
        <Input
          name="companyName"
          value={formData.companyName}
          onChange={handleInputChange}
          className="text-center"
          placeholder="Company name"
          required
        />
      ) : (
        <h2 className="text-2xl font-bold text-gray-900">
          {formData.companyName}
        </h2>
      )}
 
      {isEditing ? (
      <div className="flex items-center justify-center mt-2 w-full max-w-xs mx-auto">
          <Briefcase className="w-4 h-4 text-gray-500 mr-2" />
          <Input
            name="industryType"
            value={formData.industryType}
            onChange={handleInputChange}
            className="text-left w-full"
            placeholder="Industry type"
          />
        </div>
      ) : (
        formData.industryType && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <Briefcase className="w-4 h-4 text-gray-500 mr-1" />
            {formData.industryType}
          </div>
        )
      )}

      {/* {isEditing ? (
        <div className="flex items-center justify-center mt-2">
          <User className="w-4 h-4 text-gray-500 mr-1" />
          <Input
            name="contactPerson.name"
            value={formData.contactPerson.name}
            onChange={handleInputChange}
            className="text-center w-auto"
            placeholder="Contact person name"
          />
        </div>
      ) : (
        formData.contactPerson.name && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <User className="w-4 h-4 text-gray-500 mr-1" />
            {formData.contactPerson.name}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2">
          <Mail className="w-4 h-4 text-gray-500 mr-1" />
          <Input
            name="contactPerson.email"
            value={formData.contactPerson.email}
            onChange={handleInputChange}
            className="text-center w-auto"
            placeholder="Contact email"
          />
        </div>
      ) : (
        formData.contactPerson.email && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <Mail className="w-4 h-4 text-gray-500 mr-1" />
            {formData.contactPerson.email}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2">
          <Phone className="w-4 h-4 text-gray-500 mr-1" />
          <Input
            name="contactPerson.phone"
            value={formData.contactPerson.phone}
            onChange={handleInputChange}
            className="text-center w-auto"
            placeholder="Contact phone"
          />
        </div>
      ) : (
        formData.contactPerson.phone && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <Phone className="w-4 h-4 text-gray-500 mr-1" />
            {formData.contactPerson.phone}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2">
          <MapPin className="w-4 h-4 text-gray-500 mr-1" />
          <Input
            name="location.address"
            value={formData.location.address}
            onChange={handleInputChange}
            className="text-center w-auto"
            placeholder="Address"
          />
        </div>
      ) : (
        formData.location.address && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <MapPin className="w-4 h-4 text-gray-500 mr-1" />
            {formData.location.address}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2">
          <MapPin className="w-4 h-4 text-gray-500 mr-1" />
          <Input
            name="location.city"
            value={formData.location.city}
            onChange={handleInputChange}
            className="text-center w-auto"
            placeholder="City"
          />
        </div>
      ) : (
        formData.location.city && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <MapPin className="w-4 h-4 text-gray-500 mr-1" />
            {formData.location.city}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2">
          <MapPin className="w-4 h-4 text-gray-500 mr-1" />
          <Input
            name="location.country"
            value={formData.location.country}
            onChange={handleInputChange}
            className="text-center w-auto"
            placeholder="Country"
          />
        </div>
      ) : (
        formData.location.country && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <MapPin className="w-4 h-4 text-gray-500 mr-1" />
            {formData.location.country}
          </div>
        )
      )} */}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2 w-full max-w-xs mx-auto">
          <DollarSign className="w-4 h-4 text-gray-500 mr-2" />
          <Select
            value={formData.preferredCurrency}
            onValueChange={(value) =>
              handleInputChange({
                target: { name: "preferredCurrency", value },
              } as unknown as React.ChangeEvent<HTMLInputElement>)
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="Select currency" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectLabel>Fiat Currencies</SelectLabel>
                {CURRENCY_OPTIONS.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      ) : (
        formData.preferredCurrency && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <DollarSign className="w-4 h-4 text-gray-500 mr-1" />
            {CURRENCY_OPTIONS.find((option) => option.value === formData.preferredCurrency)?.label}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2 w-full max-w-xs mx-auto">
          <CreditCard className="w-4 h-4 text-gray-500 mr-2" />
          <Select
            value={formData.preferredPaymentMethod}
            onValueChange={(value) =>
              handleInputChange({
                target: { name: "preferredPaymentMethod", value},
              } as React.ChangeEvent<HTMLInputElement>)
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="Select payment method" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectLabel>Payment Methods</SelectLabel>
                {CRYPTO_CURRENCY_OPTIONS.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      ) : (
        formData.preferredPaymentMethod && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <CreditCard className="w-4 h-4 text-gray-500 mr-1" />
            {CRYPTO_CURRENCY_OPTIONS.find((option) => option.value === formData.preferredPaymentMethod)?.label}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex items-center justify-center mt-2 w-full max-w-xs mx-auto">
          <CreditCard className="w-4 h-4 text-gray-500 mr-2" />
          <Input
            name="vatOrGstId"
            value={formData.vatOrGstId}
            onChange={handleInputChange}
            className="text-left w-full"
            placeholder="VAT/GST ID"
          />
        </div>
      ) : (
        formData.vatOrGstId && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <CreditCard className="w-4 h-4 text-gray-500 mr-1" />
            {formData.vatOrGstId}
          </div>
        )
      )}

      {isEditing ? (
        <div className="flex flex-col items-center justify-center mt-2 ">
          <div className="flex items-center justify-center w-full max-w-xs mx-auto">
            <LinkIcon className="w-4 h-4 text-gray-500 mr-2" />
            <Input
              name="socialMediaProfile"
              value={formData.socialMediaProfile}
              onChange={handleInputChangeWithValidation}
              className="text-left w-full"
              placeholder="Social media profile"
            />
          </div>
          {errors.socialMediaProfile && (
            <p className="text-left ml-6 text-xs text-red-500">
              {typeof errors.socialMediaProfile?.message === "string" && errors.socialMediaProfile.message}
            </p>
          )}
        </div>
      ) : (
        formData.socialMediaProfile && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <LinkIcon className="w-4 h-4 text-gray-500 mr-1" />
            <a
              href={formData.socialMediaProfile}
              target="_blank"
              rel="noopener noreferrer"
            >
              {formData.socialMediaProfile}
            </a>
          </div>
        )
      )}

      {/* <div className="flex items-center justify-center mt-2 text-gray-600">
            <Star className="w-4 h-4 text-yellow-500 mr-1" />
            {formData.rating}
      </div> */}
      {/* {isEditing ? (
        <div className="flex items-center justify-center mt-2">
          <Star className="w-4 h-4 text-yellow-500 mr-1" />
          <Input
            type="number"
            min={0}
            max={5}
            name="rating"
            value={formData.rating}
            onChange={handleInputChange}
            className="text-center w-auto"
            placeholder="Rating"
          />
        </div>
      ) : (
        (formData.rating || formData?.rating ===  0 ) && (
          <div className="flex items-center justify-center mt-2 text-gray-600">
            <Star className="w-4 h-4 text-yellow-500 mr-1" />
            {formData.rating}
          </div>
        )
      )} */}
    </div>
  );
};
